<div id="wire-modified-payee-container" class="wire-modified-payee-container">
  <mm-text-input-control *ngIf="!!isoName" [parentForm]="parentForm" [inputControlModel]="payeeIsoNameModel"
    [errorMessage]="isoNameError">
  </mm-text-input-control>
</div>
